// extracted by mini-css-extract-plugin
module.exports = {"windowSize":"WindowSize_windowSize__225LJ","windowSize__badge":"WindowSize_windowSize__badge__21cM5"};